import { render, staticRenderFns } from "./index.vue?vue&type=template&id=544c6176&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=544c6176&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports